import $ from 'jquery';

class RelatedResources {
    constructor(target, settings) {
        
    }

    init() {
        this.RelatedResources();
    }

    RelatedResources() {
        let cardElements = $('.resources_cards-cards .card-wrapper');

        if (cardElements.length > 0) {
            for (let card of cardElements) {
                let url = card.getAttribute('data-url');
                if (url) {
                        $(card).css('cursor', 'pointer');
                        $(card).on('click', (e) => {
                            this.OpenWindow(url);
                    });
                }
            }
        }
    }

    OpenWindow(url) {
        if (window && url) {
            window.open(url, '_blank');
        }
    }
}

 
export default RelatedResources;

$(() => {
	const related = new RelatedResources();
	related.init();
});